import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", to.fullPath]);
      window._hmt.push(["_setAutoPageview", false]);
    }
  }
  next();
  // 获取到前面打过标签的元素，将其scrollTop属性设置为0
  document.documentElement.scrollTop = 0;
  // 滚动条可能出现在HTML元素上而不是body上，确保兼容性，同时将HTML和body中scrollTop属性设置为0
  document.body.scrollTop = 0;
  // 调用继续路由跳转
});

// router.afterEach(function (to, from) {
//   console.log(to, from, "路由");
//   if (from.path !== "/") {
//     console.log(to);
//     // 有列表页进入详情页的百度统计
//     const concatUrl = `#${to.path}${
//       to.query.messageFrom === "hw" ? "?messageFrom=hw" : ""
//     }`;
//     _hmt.push(["_trackPageview", concatUrl]);
//   }
// });
export default router;
